
/**
 * Centralized Branding Configuration
 * Change the name and logo path here to update them throughout the application.
 */

export const BRANDING = {
    name: 'YES CRM',
    logo: process.env.PUBLIC_URL + '/logoonly.png',
    footerText: '2014-' + new Date().getFullYear() + ' YES CRM, LLC. All rights reserved.',
    favicon: process.env.PUBLIC_URL + '/logoonly.png'
};

export default BRANDING;
